import React from 'react';
import Chip from '@mui/material/Chip';
import { colors } from 'Constants/Colors';
import ProgressBar from 'Components/ProgressBar';

const chipColors = [colors.GREEN, colors.RED, colors.PURPLE, colors.YELLOW, colors.BLUE, colors.PINK, colors.BROWN];

const colorCategory = {};

const useComponent = ({ categories = [] }) => {
  let counter = 0;
  categories.forEach(category => {
    if (counter === chipColors.length) counter = 0;
    colorCategory[category] = chipColors[counter];
    counter += 1;
  });

  const thereIsComponentCourses = (data, index) => {
    if (index === 3) {
      return (
        <Chip
          label={data[index]}
          style={{
            background: `${colorCategory[data[index]]}`,
            color: colors.WHITE,
          }}
        />
      );
    }
    if (index === 4) {
      const values = data[index].split('/');
      const percentage = (values[0] / values[1]) * 100;
      let value = percentage;

      if (values[0] === '0' && values[1] === '0') {
        value = 0;
      }
      return (
        <div>
          <div>{data[index]}</div>
          <ProgressBar value={value} />
        </div>
      );
    }
    return data[index];
  };

  return {
    thereIsComponentCourses,
  };
};

export default useComponent;
